import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { ChangePartLinkedGroupDetailsDto } from "@interfaces/changePartLinkedGroupDetailsDto.interface";
import { DeleteObject } from "@interfaces/dto/deleteObject.interface";
import { ImportCSV } from "@interfaces/importCSV.interface";
import { ReduceArrearsOnParts } from "@interfaces/reduceArrearsOnParts.interface";
import { Service } from "@services/service";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class PartService extends Service {
	// Every part, loaded once at login by adminRoute for the Ctrl+K search. Pages that need a part
	// picker read it from here rather than fetching the whole list again.
	allParts = new BehaviorSubject<any[]>([]);

	constructor(injector: Injector) {
		super("Part", injector);
	}

	// API
	bulkReduceArrears(data: ReduceArrearsOnParts) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/BulkReduceArrears`, data);
	}

	calculateStatistics(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CalculateStatistics/${id}`, {});
	}

	calculateStatisticsForAllCompleted() {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/CalculateStatisticsForAllCompleted`, {});
	}

	changeLinkedGroupDetails(data: ChangePartLinkedGroupDetailsDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangeLinkedGroupDetails`, data);
	}
	
	delete(data: DeleteObject) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Delete`, data);
	}

	duplicate(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Duplicate/${id}`, {});
	}

	exportTimingsCSV() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ExportTimingsCSV`, { responseType: "blob" as "json"});
	}

	getBySpecificationSupplier(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetBySpecificationSupplier/${id}`);
	}

	getDeleted() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Deleted`);
	}

	getLinkedParts(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetLinkedParts/${id}`);
	}

	getMasterParts() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/MasterParts`);
	}
	
	getSubPartsForMaster(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/SubPartsForMaster/${id}`);
	}
	
	getUnlinkedParts() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetUnlinkedParts`);
	}
	
	importCSV(data: ImportCSV) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ImportCSV`, data);
	}
	
	importTimingsCSV(data: ImportCSV) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ImportTimingsCSV`, data);
	}
	
	incrementBPLVersion(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/IncrementBPLVersion/${id}`, {});
	}

	partExists(partNumber: string) {
		// A query parameter, not a path segment - a part number with a / in it never matched the route.
		return this.http.get<{exists: boolean, partId: number | null}>(`${environment.server.apiURL}/${this.endpoint}/PartExists`, { params: { partNumber } });
	}

	purchaseSpecifications(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PurchaseSpecifications/${id}`);
	}
}